import Switcher from '@kuik/modules/switcher/switcher.js';
import {destroyAllMenuMobile, initAllMenuMobile} from '@kuik/tags/menu-mobile/menu-mobile.js';

/**
 * Gère le switch des menus.
 */
export function handleSwitch() {
    const componentMenu = document.getElementById('component-menu');
    const componentMenuDesktop = document.getElementById('component-menu-desktop');
    const componentSwitcher = new Switcher('menu-mobile', {
        element: componentMenu,
        onMounted() {
            initAllMenuMobile();
        }
    });
    // Ajoute une 2e variante (exemple de composant asynchrone)
    componentSwitcher.registerComponent('menu-desktop', {
        element: componentMenuDesktop,
        onMounted() {
            destroyAllMenuMobile();
        }
    });
    // Charger le composant mobile si la largeur de l'écran < 868px
    let lastWidth = null;
    new ResizeObserver(([{contentRect: {width}}]) => {
        if (width !== lastWidth) {
            lastWidth = width;
            componentSwitcher.switch(width >= 868 ? 'menu-desktop' : 'menu-mobile');
        }
    }).observe(document.body.parentElement);
    return componentSwitcher;
}

window.addEventListener('load', handleSwitch());
